import { render, staticRenderFns } from "./UpdateJobAddress.vue?vue&type=template&id=62cb3f74&scoped=true&"
import script from "./UpdateJobAddress.vue?vue&type=script&lang=js&"
export * from "./UpdateJobAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62cb3f74",
  null
  
)

export default component.exports